import React from 'react'
import { Button, Modal } from 'react-angle-dashboard-components'
import { Link } from 'react-router-dom'
import pendulum from './pendulum.gif'
import { ReactComponent as ExclaimationImg } from '../../../../assets/exclaimationCircle.svg'
import { Paths } from '../../../../routes/paths'

interface ICensusRishModalProps {
  open: boolean
  isLoading: boolean
  onClose: () => void
  onSaveAsDraft: () => void
}

export const CensusRiskModal = ({
  open,
  isLoading,
  onClose,
  onSaveAsDraft
}: ICensusRishModalProps) => {
  return (
    <>
      <Modal
        style={{
          zIndex: 9000
        }}
        centered
        show={open}
        size="lg"
      >
        <Modal.Header className="border-bottom pb-2" closeButton={!isLoading}>
          <h5>Submit Census Info</h5>
        </Modal.Header>
        {!isLoading ? (
          <Modal.Body className="d-flex flex-column align-items-center">
            <div>
              <ExclaimationImg
                fill="#DC3545"
                style={{
                  width: 36,
                  height: 36,
                  overflow: 'visible',
                  marginBottom: 20
                }}
              />
            </div>
            <h5 className="text-center">
              Group Exceeds Risk Parameters: Quote Unavailable
            </h5>
            <p className="text-center">
              Your group's characteristics exceed our risk parameters, making it
              ineligible for a quote at this time. Please save this as a draft
              and reach out to{' '}
              <a href="mailto: sales@anglehealth.com">sales@anglehealth.com</a>{' '}
              for more information, or you can go back to the census information
              page to make edits and try again.
            </p>
          </Modal.Body>
        ) : (
          <Modal.Body className="d-flex flex-column align-items-center">
            <div style={{ width: 100, height: 100 }}>
              <img
                style={{ maxWidth: '100%', maxHeight: '100%' }}
                src={pendulum}
                alt="Loading..."
              />
            </div>

            <h5>Assessing plan and census info</h5>
            <p className="text-secondary">
              This process may take 30 seconds or more. If you'd prefer not to
              wait, please feel free to check back in a few minutes.
            </p>
            <Link to={Paths.quotes}>
              <Button variant="outline-primary">View All Quotes</Button>
            </Link>
          </Modal.Body>
        )}

        {!isLoading && (
          <Modal.Footer>
            <Button
              className="py-2"
              variant="outline-primary"
              onClick={onClose}
            >
              Return to Census
            </Button>
            <Button className="py-2" onClick={onSaveAsDraft}>
              Save as Draft
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    </>
  )
}

export default CensusRiskModal
